import {
  pgTable,
  text,
  timestamp,
  uuid,
  integer,
  jsonb,
  index,
  check,
} from "drizzle-orm/pg-core";
import { sql } from "drizzle-orm";

const tz = { withTimezone: true } as const;

export const CHECKPOINT_STATUSES = [
  "pending",
  "approved",
  "rejected",
  "expired",
] as const;

export const CHECKPOINT_DOMAINS = [
  "page",
  "blog",
  "section",
  "form",
] as const;

export type CheckpointStatus = (typeof CHECKPOINT_STATUSES)[number];
export type CheckpointDomain = (typeof CHECKPOINT_DOMAINS)[number];

export const aiCheckpoints = pgTable(
  "ai_checkpoints",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    domain: text("domain").notNull(),
    actionRef: text("action_ref").notNull(),
    status: text("status").notNull().default("pending"),
    initiatedBy: text("initiated_by").notNull(),
    resolvedBy: text("resolved_by"),
    resolvedAt: timestamp("resolved_at", tz),
    currentVersion: integer("current_version").notNull().default(1),
    context: jsonb("context")
      .$type<Record<string, unknown>>()
      .notNull()
      .default({}),
    resultEntityId: uuid("result_entity_id"),
    expiresAt: timestamp("expires_at", tz).notNull(),
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
  },
  (table) => [
    index("idx_ai_checkpoints_tenant_status").on(table.tenantId, table.status),
    index("idx_ai_checkpoints_expires").on(table.expiresAt),
    check(
      "chk_ai_checkpoints_status",
      sql`${table.status} IN ('pending', 'approved', 'rejected', 'expired')`,
    ),
    check(
      "chk_ai_checkpoints_domain",
      sql`${table.domain} IN ('page', 'blog', 'section', 'form')`,
    ),
  ],
);

export const aiCheckpointVersions = pgTable(
  "ai_checkpoint_versions",
  {
    checkpointId: uuid("checkpoint_id")
      .notNull()
      .references(() => aiCheckpoints.id, { onDelete: "cascade" }),
    versionNumber: integer("version_number").notNull(),
    output: jsonb("output")
      .$type<Record<string, unknown>>()
      .notNull(),
    promptUsed: text("prompt_used").notNull(),
    generationMetadata: jsonb("generation_metadata")
      .$type<Record<string, unknown>>()
      .default({}),
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
  },
  (table) => [
    index("idx_ai_cv_checkpoint").on(table.checkpointId),
  ],
);
